<template>
  <v-container fluid>
    <v-combobox
      v-model="params"
      :items="items"
      :search-input.sync="search"
      label="Параметры"
      item-value="slug"
      multiple
      persistent-hint
      small-chips
      no-filter
    >
      <template #selection="{ attrs, item, parent }">
        <v-chip label outlined v-bind="attrs">
          <span class="pr-2">
            {{ item.name }}
          </span>
          <v-icon small @click="parent.selectItem(item)">
            mdi-close
          </v-icon>
        </v-chip>
      </template>
      <template #item="{ item }">
        {{ item.name }}
      </template>

      <template #no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title> Введите для поиска </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-combobox>
  </v-container>
</template>

<script>
import { getParams } from '@/graphql/offers'
  export default {
        apollo: {
             Params: {
              query: getParams,
              result ({ data, loading }) {
                  if (data.getParams !== undefined && data.getParams.params !== null) {
                    this.paramsList = data.getParams.params
                  }
              },
                 variables () {
                    return {
                    search: this.search,
                    limit: 20,
                    offset: 0
                    }
                  },
              update: data => data.getParams
            }
        },
      props: {
          default: {
              type: Array,
            default: () => {
              return [
                {
                  id: 0,
                  name: ''
                }
              ]
            }
          },
          openDialog: {
            type: Boolean
          }
      },
    data: () => ({
      params: [],
      items: [],
      search: null
    }),
    watch: {
      openDialog (val) {
        if (val) {
          this.params = []
          if (this.default !== undefined) {
             this.params = this.default
          }
        }
      },
        params (val) {
             this.$emit('selected', val)
        },
      search (val) {
        if (val && val.length > 3) {
          this.$apollo.queries.Params.refetch()
        }
      }
    }
  }
</script>
